export const suffixOptions = ["II", "III", "IV", "Jr", "Sr"];
//# sourceMappingURL=suffix.js.map